import { render, staticRenderFns } from "./JTreeSelectCustom.vue?vue&type=template&id=c2142a48&"
import script from "./JTreeSelectCustom.vue?vue&type=script&lang=js&"
export * from "./JTreeSelectCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports